"use dom";
import { useCallback, useEffect, useRef, useState } from "react";

export default function OnboardingProductDemo({
	onNext,
	demoUrl,
}: { onNext: () => void; demoUrl: string }) {
	const [isLastStep, setIsLastStep] = useState(false);
	const isLastStepRef = useRef(false);

	useEffect(() => {
		isLastStepRef.current = isLastStep;
	}, [isLastStep]);

	const handleMessage = useCallback(
		(event: MessageEvent) => {
			const { eventSource, eventName, isFinalStep } = event?.data || {};
			if (eventSource === "Arcade") {
				if (eventName === "Step Reached") {
					setIsLastStep(isFinalStep);
				} else if (eventName === "Hotspot Clicked" && isLastStepRef.current) {
					onNext();
				}
			}
		},
		[onNext],
	);
	return (
		<iframe
			src={demoUrl}
			title="TOEFL Practice | Home"
			loading="lazy"
			allowFullScreen
			allow="clipboard-write"
			style={{
				display: "flex",
				flex: 1,
				colorScheme: "light",
				padding: 24,
				border: 0,
			}}
			onLoad={() => {
				window.addEventListener("message", handleMessage);
			}}
		/>
	);
}
